import { FC, useEffect, useMemo, useState } from 'react'
import { Box, CircularProgress } from '@mui/material'

import { RestrictionTable } from '@components/ConfigRestrictions/components/RestrictionTable'

import { useRestrictions } from '@hooks'
import { FormattedColumnRestrictions, GETEntityColumn } from '@types'

type TProps = {
  viewId: number
  rows: GETEntityColumn[]
  hiddenColumns?: string[]
}

export const ConfigRestrictions: FC<TProps> = ({ viewId, rows, isHideSort, hiddenColumns }) => {
  const { restrictions, updateRestrictions, getRestrictions } = useRestrictions(viewId, true)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getRestrictions(viewId).finally(() => setLoading(false))
  }, [viewId])

  const restrictionsDataRows: FormattedColumnRestrictions[] = useMemo(
    () =>
      rows
        .map(row => {
          const order = restrictions?.order?.find(rOrder => rOrder.fieldCode === row.code)
          const width = restrictions?.width?.find(rWidth => rWidth.fieldCode === row.code)
          const sort = restrictions?.sort?.find(rSort => rSort.fieldCode === row.code)
          const show = restrictions?.show?.find(rShow => rShow.fieldCode === row.code)
          const quickSearchChoice = restrictions?.quickSearchChoice?.find(
            rQSChoice => rQSChoice.fieldCode === row.code
          )
          const quickSearchPermission = restrictions?.quickSearchPermission?.find(
            rQSPermission => rQSPermission.fieldCode === row.code
          )
          const fix = restrictions.fix?.find(rFix => rFix.fieldCode === row.code)

          return {
            ...row,
            fieldCode: row.code,
            fieldName: row.title,
            order,
            width,
            fix,
            show,
            sort: {
              columnToSort: row.columnToSort,
              ...sort?.value,
            },
            quickSearchChoice,
            quickSearchPermission,
          }
        })
        .sort(({ order: orderA }, { order: orderB }) => orderA?.value - orderB?.value),
    [restrictions, rows]
  )
  if (loading) {
    return (
      <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <RestrictionTable
      hiddenColumns={hiddenColumns}
      restrictionsDataRows={restrictionsDataRows}
      updateRestrictions={updateRestrictions}
      viewId={viewId}
    />
  )
}
